export default __webpack_public_path__ + "static/media/warning--road-blocks--g1.b88715e8.png";